// Pure TypeScript. No React. No imports from features or services.
//
// The single class-name composer used by every component in shared/ui.
// clsx resolves conditionals; tailwind-merge de-duplicates conflicting
// Tailwind utilities so `cn("p-2", "p-4")` yields "p-4", not both.

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
